import { render } from "./settings.html?vue&type=template&id=be1aef9e"
import script from "./Settings.vue?vue&type=script&lang=ts"
export * from "./Settings.vue?vue&type=script&lang=ts"

import "./Settings.vue?vue&type=style&index=0&id=be1aef9e&lang=scss"
script.render = render

export default script